/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Same validated sample as the result matrix; newest draw first. */
(function (root, factory) {
    'use strict';
    var api = factory();
    if (typeof module === 'object' && module.exports) module.exports = api;
    else { root.PewniakiRytmyWynikow = api; api.start(root.document, root); }
})(typeof window === 'undefined' ? globalThis : window, function () {
    'use strict';
    function powtorzenie(pattern) {
        var best = null;
        for (var size = 1; size * 2 <= pattern.length; size++) {
            var unit = pattern.slice(-size);
            if (!unit.includes('1')) continue;
            var repeats = 1;
            while ((repeats + 1) * size <= pattern.length
                && pattern.slice(pattern.length - (repeats + 1) * size, pattern.length - repeats * size) === unit) repeats++;
            var span = repeats * size;
            if (repeats >= 2 && (!best || span > best.span || (span === best.span && size < best.unit.length)))
                best = { unit: unit, repeats: repeats, span: span };
        }
        return best;
    }
    function oblicz(draws, pool, L) {
        if (!Array.isArray(draws) || !Number.isInteger(pool) || pool < 1 || pool > 80
            || !Number.isInteger(L) || L < 2 || L > 12) return { status: 'invalid', top: [] };
        var bits = Array.from({ length: pool }, function () { return ''; });
        for (var i = Math.min(draws.length, L) - 1; i >= 0; i--) {
            var ns = draws[i] && draws[i].numbers;
            if (!Array.isArray(ns) || !ns.length || new Set(ns).size !== ns.length
                || ns.some(function (n) { return !Number.isInteger(n) || n < 1 || n > pool; })) return { status: 'invalid', top: [] };
            var hits = new Set(ns);
            for (var n = 1; n <= pool; n++) bits[n - 1] += hits.has(n) ? '1' : '0';
        }
        var N = draws.length;
        if (N < L) return { status: 'short', N: N, L: L, top: [] };
        var rows = bits.map(function (s, index) {
            var repeat = powtorzenie(s);
            return repeat ? { n: index + 1, pattern: s, unit: repeat.unit, repeats: repeat.repeats, span: repeat.span } : null;
        }).filter(Boolean);
        rows.sort(function (a, b) { return b.span - a.span || b.repeats - a.repeats || a.n - b.n; });
        return { status: 'ok', N: N, L: L, total: rows.length, top: rows.slice(0, 10),
            from: draws[L - 1].drawn_at, to: draws[0].drawn_at };
    }
    function start(doc, win) {
        function init() {
            var section = doc.querySelector('[data-wyniki-rytmy]'), matrix = doc.querySelector('[data-wyniki]');
            if (!section || !matrix) return;
            var select = section.querySelector('[data-wyniki-rytmy-dlugosc]'), list = section.querySelector('[data-wyniki-rytmy-lista]'),
                info = section.querySelector('[data-wyniki-rytmy-opis]'), lang = (doc.documentElement.lang || '').toLowerCase(), de = /^de(?:-|$)/.test(lang), en = /^en(?:-|$)/.test(lang), game = matrix.dataset.gra,
                pool = Number(section.dataset.pula), sample = win.PewniakiWynikiZakres;
            function date(value) {
                var d = new Date(value);
                return Number.isNaN(d.getTime()) ? '—' : d.toLocaleString(de ? 'de-DE' : (jst("pages_rytmy_wyniki_js.f7ae2a9db5f0")), { timeZone: de ? 'Europe/Berlin' : 'Europe/Warsaw', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
            }
            function render() {
                section.hidden = false; list.replaceChildren();
                if (!sample || sample.game !== game || sample.missing) {
                    info.textContent = de ? jst("ui.b589a8d3f81c22ac") : (jst("pages_rytmy_wyniki_js.8b9317da3f6d"));
                    return;
                }
                var result = oblicz(sample.draws, pool, Number(select.value));
                if (result.status === 'invalid') {
                    info.textContent = de ? jst("ui.6c3250f87104df5e") : (jst("pages_rytmy_wyniki_js.4455da3ed21d"));
                    return;
                }
                if (result.status === 'short') {
                    info.textContent = jst("pages_rytmy_wyniki_js.pattern_minimum", [result.N, result.L]);
                    return;
                }
                info.textContent = 'N = ' + result.N + ' · ' + (de ? jst("fragment.cd79cc95ad4a58e1") : (jst("pages_rytmy_wyniki_js.4d74ef3eac8d"))) + result.L + ' · ' + date(result.from) + ' — ' + date(result.to) + '. '
                    + (de ? jst("ui.64348324da04f6f4") : (jst("pages_rytmy_wyniki_js.f30eaadbecd7"))) + result.total + jst("pages_rytmy_wyniki_js.display_limit");
                if (!result.top.length) info.textContent += de ? jst("ui.f23bb1a9bd12124a") : (jst("pages_rytmy_wyniki_js.7b76c62fc779"));
                result.top.forEach(function (row) {
                    var item = doc.createElement('div'), ball = doc.createElement('span'), pattern = doc.createElement('span'), code = doc.createElement('code'), count = doc.createElement('strong');
                    item.className = 'wyniki-rytmy__liczba'; item.dataset.wynikiRytmLiczba = row.n;
                    ball.className = 'kula kula--' + game; ball.textContent = row.n;
                    pattern.className = 'rytm-wzor rytm-wzor--' + game; pattern.setAttribute('role', 'img'); pattern.setAttribute('aria-label', row.pattern);
                    row.pattern.split('').forEach(function (bit) { var square = doc.createElement('span'); square.className = 'rytm-bit rytm-bit--' + bit; square.setAttribute('aria-hidden', 'true'); pattern.appendChild(square); });
                    code.textContent = row.pattern; count.textContent = row.unit + ' × ' + row.repeats;
                    item.dataset.rytmJednostka = row.unit; item.dataset.rytmPowtorzenia = row.repeats; item.dataset.rytmDlugosc = row.span;
                    item.append(ball, pattern, code, count); list.appendChild(item);
                });
            }
            matrix.addEventListener('pewniaki:wyniki-zakres', function (event) { sample = event.detail; render(); });
            select.addEventListener('change', render);
            render();
        }
        if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
    }
    return { oblicz: oblicz, powtorzenie: powtorzenie, start: start };
});
